import { ANIMATION_TYPES } from '@website-editor/context/NavigationPaneContext/NavigationPane.constants';
import { CUSTOM_PAGE_ACTIONS } from '@website-editor/customComponents/CustomComponents.constants';

export enum PHOTO_ACTIONS {
  PHOTO_ADD = 'photo_add',
  PHOTO_EDIT = 'photo_edit',
}

export const PHOTO_SCREENS = [PHOTO_ACTIONS.PHOTO_ADD, PHOTO_ACTIONS.PHOTO_EDIT];

export const PHOTO_ANIMATION_CONFIG = {
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS]: [
    {
      navigatedFrom: PHOTO_ACTIONS.PHOTO_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: PHOTO_ACTIONS.PHOTO_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD]: [
    {
      navigatedFrom: PHOTO_ACTIONS.PHOTO_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: PHOTO_ACTIONS.PHOTO_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [PHOTO_ACTIONS.PHOTO_ADD]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [PHOTO_ACTIONS.PHOTO_EDIT]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
};
